<template>
  <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" :title="$langmsg.main_bank" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>

    <van-tabs v-model="type">
      <!-- USDT -->
      <van-tab title="USDT" name="1">
        <div class="lis" v-for="(item, index) in usdssLis" :key="index">
          <img class="lefs" src="/static/image/1595237922936176.png" alt="" />
          <div class="cest">
            <div class="type">{{ item.bank }}-{{ item.bank_owner }}</div>
            <div class="num">
              <span>****</span><span>****</span><span>****</span><span>{{ item.bank_no.substr(-4) }}</span>
            </div>
          </div>
          <img class="rigss" @click="delCard(item.id)" src="/static/style/wdb_icon.png" alt="" />
        </div>
        <div class="adds">
          <van-button v-if="usdssLis.length < 5" plain style="width: 100%" @click="$parent.goNav('/addUsdtCard')">添加USDT地址</van-button>
          <van-button v-else disabled plain style="width: 100%">已达上限(5个)</van-button>
          <div class="btntits">{{ $langmsg.wap_zddz }}</div>
        </div>
      </van-tab>

      <!-- 银行卡 -->
      <van-tab :title="$langmsg.main_mybank" name="2">
        <div class="lis" v-for="(item, index) in usercardLis" :key="index">
          <img class="lefs" :src="item.ico" alt="" />
          <div class="cest">
            <div class="type">{{ item.bank }}</div>
            <div class="type">{{ item.bank_owner }}</div>
            <div class="num">
              <span>****</span><span>****</span><span>****</span><span>{{ item.bank_no.substr(-4) }}</span>
            </div>
          </div>
          <img class="rigss" @click="delCard(item.id)" src="/static/style/wdb_icon.png" alt="" />
        </div>
        <div class="adds">
          <van-button v-if="usercardLis.length < 5" @click="$parent.goNav('/addBankCard')" plain style="width: 100%">{{ $langmsg.bank_bank_bd }}</van-button>
          <van-button v-else disabled plain style="width: 100%">已达上限(5张)</van-button>
          <div class="btntits">{{ $langmsg.bank_yz_bksl }}</div>
        </div>
      </van-tab>

      <!-- 微信 -->
      <van-tab title="微信" name="3">
        <div class="lis" v-for="(item, index) in wxcardLis" :key="index">
          <img class="lefs" src="/static/image/wechat_icon.png" onerror="this.style.display='none'" alt="" />
          <div class="cest">
            <div class="type">{{ item.bank_owner }}</div>
            <div class="type" style="font-size:0.32rem">{{ item.bank_no }}</div>
            <div class="type" style="font-size:0.28rem" v-if="item.qr_code">
              <img :src="'/' + item.qr_code" style="width:1.5rem;margin-top:6px;border-radius:4px" alt="收款码" />
            </div>
          </div>
          <img class="rigss" @click="delCard(item.id)" src="/static/style/wdb_icon.png" alt="" />
        </div>
        <div class="adds">
          <van-button v-if="wxcardLis.length < 5" plain style="width: 100%" @click="$parent.goNav('/addWxCard')">+绑定微信</van-button>
          <van-button v-else disabled plain style="width: 100%">已达上限(5个)</van-button>
          <div class="btntits">最多绑定5个微信账号</div>
        </div>
      </van-tab>

      <!-- 支付宝 -->
      <van-tab title="支付宝" name="4">
        <div class="lis" v-for="(item, index) in alicardLis" :key="index">
          <img class="lefs" src="/static/image/alipay_icon.png" onerror="this.style.display='none'" alt="" />
          <div class="cest">
            <div class="type">{{ item.bank_owner }}</div>
            <div class="type" style="font-size:0.32rem">{{ item.bank_no }}</div>
            <div class="type" style="font-size:0.28rem" v-if="item.qr_code">
              <img :src="'/' + item.qr_code" style="width:1.5rem;margin-top:6px;border-radius:4px" alt="收款码" />
            </div>
          </div>
          <img class="rigss" @click="delCard(item.id)" src="/static/style/wdb_icon.png" alt="" />
        </div>
        <div class="adds">
          <van-button v-if="alicardLis.length < 5" plain style="width: 100%" @click="$parent.goNav('/addAlipayCard')">+绑定支付宝</van-button>
          <van-button v-else disabled plain style="width: 100%">已达上限(5个)</van-button>
          <div class="btntits">最多绑定5个支付宝账号</div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'wallet',
  data() {
    return {
      usercardLis: [],
      usdssLis: [],
      wxcardLis: [],
      alicardLis: [],
      type: '1',
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type;
    }
    that.getUsercard();
    that.getUsdssList();
    that.getWxcardLis();
    that.getAlicardLis();
  },
  methods: {
    delCard(id) {
      let that = this;
      that.$dialog.confirm({
        title: this.$langmsg.tc_tips,
        message: this.$langmsg.bank_yz_khs,
      }).then(() => {
        that.$parent.showLoading();
        that.$apiFun.post('/api/delcard', { card_id: id }).then(res => {
          that.$parent.hideLoading();
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          } else {
            that.$parent.showTost(1, this.$langmsg.bank_success_jb);
            that.getUsercard();
            that.getUsdssList();
            that.getWxcardLis();
            that.getAlicardLis();
          }
        });
      }).catch(() => {});
    },
    getUsercard() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) that.usercardLis = res.data;
      });
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) that.usdssLis = res.data;
      });
    },
    getWxcardLis() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 3 }).then(res => {
        if (res.code == 200) that.wxcardLis = res.data;
      });
    },
    getAlicardLis() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 4 }).then(res => {
        if (res.code == 200) that.alicardLis = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.adds {
  width: 60%;
  margin: 0 auto;
  margin-top: 100px;
  .btntits {
    text-align: center;
    margin-top: 20px;
    font-size: 0.28rem;
    color: #6c6e82;
  }
}
.lis {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  margin: 0 auto;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 10px 25px;
  min-height: 80px;
  border-radius: 10px;
  position: relative;
  background: #fff;
  .lefs {
    width: 1.5rem;
  }
  .cest {
    flex: 1;
    margin: 0 20px;
    .type {
      font-size: 0.4rem;
      font-weight: 700;
      color: #98a8c5;
      margin-top: 6px;
    }
    .num {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 6px;
      color: #98a8c5;
      span {
        font-size: 0.6rem;
      }
    }
  }
  .rigss {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wallet.vue